<div class="sh-page-template__main__content sh-report-detail">
    <sh-page-header
        [title]="reportTitle$ | async"
        [contextItems]="reportDescription$ | async"
        [primaryNavigationItems]="navigationItems"
        [fullWithContext]="true"
    ></sh-page-header>

    <div class="sh-panel sh-report-detail__panel" *ngIf="(reportEmbedUrl$ | async) as url">
        <iframe title="report" class="sh-report__panel__frame" [src]="url | safeResourceUrl"></iframe>
    </div>

    <sh-notification
        *ngIf="error$ | async"
        [message]="'reports.detail.messages.failed-to-fetch' | translate"
        [type]="notificationType.Error"
        [icon]="'delete'"
    ></sh-notification>
    <sh-notification *ngIf="loading$ | async" [message]="'ui.loading' | translate"></sh-notification>
</div>
